import { useEffect, useState } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { initialOption, Toption } from '../../../type/option';
import { initialStore, Tstore } from '../../../type/store';
import { showMessage } from '../../../utls/message';
import {
	getCity,
	getDistrict,
	getProvinsi,
} from '../../../service/locationService';
import { Tprovinsi } from '../../../type/provinsi';
import { Tcity } from '../../../type/city';
import {
	ButtonBlockPrimary,
	FormGroup,
	InputPhoneNumber,
	InputTextArea,
	InputTextblock,
	Layout,
	SelectDropDown,
} from '../../../components';
import { useNavigate, useParams } from 'react-router-dom';
import { initialDistrict, Tdistrict } from '../../../type/district';
import {
	getDataStoreDetail,
	postData,
} from '../../../service/usersStoreService';

const OfflineStoreCreate = () => {
	const navigate = useNavigate();
	const { uniqueId } = useParams();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const [provinsiList, setProvinsiList] = useState<Toption[]>([]);
	const [selectProvinsi, setSelectProvinsi] = useState<Toption>();
	const [cityList, setCityList] = useState<Toption[]>([]);
	const [selectCity, setSelectCity] = useState<Toption>();
	const [districtList, setDistrictList] = useState<Toption[]>([]);
	const [selectDistrict, setSelectDistrict] = useState<Toption>();
	const [id, setId] = useState(0);
	const [name, setName] = useState('');
	const [address, setAddress] = useState('');
	const [phone, setPhone] = useState('');
	const [postalCode, setPostalCode] = useState('');
	const [active, setActive] = useState(true);

	const onSubmit = async () => {
		setIsLoading(true);

		if (name == null || name == '') {
			return showMessage('Nama toko tidak boleh kosong', 'error');
		}

		console.log(phone);

		if (!phone || (phone && !isValidPhoneNumber(phone))) {
			return showMessage('Format No Hp tidak sesuai ', 'error');
		}

		console.log(selectDistrict);

		if (!selectDistrict || selectDistrict?.data == null) {
			return showMessage('Alamat Belum Di isi dengan Benar', 'error');
		}

		if (address == null || address == '') {
			return showMessage('Alamat toko tidak boleh kosong', 'error');
		}

		const data: any = {
			id: id > 0 ? id : undefined,
			name: name,
			phone: phone,
			address: address,
			district: {
				id: selectDistrict?.data?.id || 0
			},
			postalCode: postalCode,
			active: active,
			partner: false
		};

		const response = await postData(data);
		if (response?.code === 200 && !response?.error) {
			navigate(-1);

			setIsLoading(false);
			return;
		}

		showMessage('Kesalahan pada server', 'error');
		setIsLoading(false);
	};

	const getCurrentData = async () => {
		const response = await getDataStoreDetail(uniqueId ?? '');
		if (response?.code === 200 && !response?.error) {
			const store: Tstore = response.data;

			setId(store.id);
			setName(store.name);
			setPhone(store.phone);
			setPostalCode(store.postalCode);
			setAddress(store.address);

			if (store.district) {
				setSelectDistrict({
					label: store.district.districtName,
					value: store.district.id?.toString() || '0',
					data: store?.district,
				});

				setSelectCity({
					label: store.district.city.cityName,
					value: store.district.city.id?.toString() || '0',
					data: store?.district.city,
				});

				setSelectProvinsi({
					label: store.district.city.provinsi.provinsiName,
					value: store.district.city.provinsi.id?.toString() || '0',
					data: store?.district.city.provinsi,
				});
			}
		}
	};

	const getDataProvinsi = async (keyword: string) => {
		const data = {
			keyword: keyword,
		};
		const response = await getProvinsi(data);
		if (!response?.error) {
			const items: Toption[] = [];
			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tprovinsi) => {
				items.push({
					label: item.provinsiName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setProvinsiList(items);
		}
	};

	const getDataCity = async (keyword: string, provinsiId: string) => {
		const data = {
			keyword: keyword,
			provinsiId: provinsiId,
		};
		const response = await getCity(data);
		if (!response?.error) {
			const items: Toption[] = [];

			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tcity) => {
				items.push({
					label: item.cityName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setCityList(items);
		}
	};

	const getDataDistrict = async (keyword: string, cityId: string) => {
		const data = {
			keyword: keyword,
			cityId: cityId,
		};
		const response = await getDistrict(data);
		if (!response?.error) {
			const items: Toption[] = [];
			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tdistrict) => {
				items.push({
					label: item.districtName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setDistrictList(items);
		}
	};

	useEffect(() => {
		uniqueId && getCurrentData();

		getDataProvinsi('');
	}, [uniqueId]);

	return (
		<Layout
			title="Tambahkan Toko Offline"
			showNavBar={true}
			showNavigation={false}
		>
			<div className="font-bold mb-16 pb-2 b" />
			<FormGroup label={'Nama Toko *'}>
				<InputTextblock
					value={name}
					onChange={(e) => {
						setName(e.target.value);
					}}
					placeholder="Masukan nama toko"
				/>
			</FormGroup>
			<FormGroup label="Phone *">
				<InputPhoneNumber
					onChage={(e) => setPhone(e)}
					value={phone}
				/>
			</FormGroup>
			<FormGroup label={'Provinsi'}>
				<SelectDropDown
					options={provinsiList}
					value={selectProvinsi}
					onChange={(e: Toption) => {
						setSelectProvinsi(e);
						if (e !== selectProvinsi) {
							setSelectCity(initialOption);
							setSelectDistrict(initialOption);
							getDataCity('', e.value);
							getDataDistrict('', '0');
						}
						getDataCity('', e.value);
					}}
					onInputChange={(e) => {
						getDataProvinsi(e);
					}}
				/>
			</FormGroup>
			<FormGroup label={'Kota'}>
				<SelectDropDown
					options={cityList}
					value={selectCity}
					onChange={(e) => {
						setSelectCity(e);
						if (e !== selectCity) {
							setSelectDistrict(initialOption);
							getDataDistrict('', e.value);
						}
					}}
					onInputChange={(e) => {
						getDataCity(e, selectProvinsi?.value || '');
					}}
				/>
			</FormGroup>
			<FormGroup label={'Kecamatan *'}>
				<SelectDropDown
					options={districtList}
					value={selectDistrict}
					onChange={(e) => {
						setSelectDistrict(e);
					}}
					onInputChange={(e) => {
						getDataDistrict(e, selectCity?.value || '');
					}}
				/>
			</FormGroup>
			<FormGroup label={'Kode pos'}>
				<InputTextblock
					value={postalCode}
					onChange={(e) => {
						setPostalCode(e.target.value);
					}}
					placeholder="Masukan kode pos"
				/>
			</FormGroup>
			<FormGroup label={'Alamat *'}>
				<InputTextArea
					value={address}
					onChange={(e) => setAddress(e.target.value)}
					placeholder="Alamat"
				/>
			</FormGroup>
			<div className="my-8">
				<ButtonBlockPrimary
					disabled={isLoading}
					onClick={() => {
						onSubmit();
					}}
					label="Tambahkan"
				/>
			</div>
		</Layout>
	);
};

export default OfflineStoreCreate;
